import React from 'react';
import { motion } from 'framer-motion';
import { MONTHLY_PRICE, SETUP_PRICE, VAT_MENTION, formatEuro } from './offerData';
import { OfferFormCta, OfferWhatsAppCta } from './OfferCtaButtons';

const OfferFinalCta: React.FC = () => (
  <section className="section-spacing bg-canvas border-t border-line">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="rounded-2xl border border-accent/35 bg-gradient-to-r from-accent/20 via-accent/10 to-accent/10 p-7 md:p-8 text-center"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <h2 className="text-balance text-xl md:text-2xl font-bold text-fg mb-3">Prêt à être trouvé par vos clients ?</h2>
        <p className="text-fg text-sm md:text-base mb-6">
          {formatEuro(SETUP_PRICE)} à la mise en ligne, puis {formatEuro(MONTHLY_PRICE)}/mois : maintenance, mises à jour et modifications incluses. {VAT_MENTION}.
        </p>
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
          <OfferWhatsAppCta location="final" />
          <OfferFormCta location="final" />
        </div>
      </motion.div>
    </div>
  </section>
);

export default OfferFinalCta;
